const Coupon = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/Coupon.vue')
const CouponDetail = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/CouponDetail.vue')
const CouponManage = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/CouponManage.vue')
const IssueCoupon = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/IssueCoupon.vue')

const QuotaCouponDetail = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/QuotaCoupon/QuotaCouponDetail.vue')

const QuotaCouponResend = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/QuotaCoupon/QuotaCouponResend.vue')

const QuotaCouponIssue = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/QuotaCoupon/QuotaCouponIssue.vue')

const QuotaCouponManage = () =>
  import(/* webpackChunkName: "coupon" */ '@/views/coupon/QuotaCoupon/QuotaCouponManage.vue')

export default function(router) {
  router.push({
    path: '/',
    component: Coupon,
    redirect: '/cost/coupon'
  })

  // 代金券列表
  router.push({
    path: '/cost/coupon',
    name: 'conponList',
    component: Coupon
  })
  // 代金券列表-兼容老路径
  router.push({
    path: '/coupon/couponinfo',
    redirect: '/cost/coupon'
  })
  // 代金券详情
  router.push({
    path: '/cost/coupon-detail',
    name: 'couponDetail',
    component: CouponDetail
  })
  // 代金券详情-兼容老路径
  router.push({
    path: '/cost/couponDetail',
    redirect: '/cost/coupon-detail'
  })
  // 券额管理
  router.push({
    path: '/cost/coupon-limitation',
    name: 'couponManage',
    component: CouponManage,
    meta: {
      isOldVersion: true // 校验权限是否为旧版
    }
  })
  // 券额管理-兼容老路径
  router.push({
    path: '/cost/couponManage',
    redirect: '/cost/coupon-limitation'
  })
  //发放代金券
  router.push({
    path: '/cost/issue-coupon',
    name: 'issueCoupon',
    component: IssueCoupon,
    meta: {
      isOldVersion: true // 校验权限是否为旧版
    }
  })
  //发放代金券-兼容老项目
  router.push({
    path: '/cost/issueCoupon',
    redirect: '/cost/issue-coupon'
  })

  //新版券额管理
  router.push({
    path: '/cost/quota-coupon',
    name: 'quotaCouponManage',
    component: QuotaCouponManage,
    meta: {
      isNewVersion: true // 校验权限是否为新版
    }
  })
  //新版券额详情
  router.push({
    path: '/cost/quota-coupon-detail',
    name: 'quotaCouponDetail',
    component: QuotaCouponDetail,
    meta: {
      isNewVersion: true // 校验权限是否为新版
    }
  })

  //新版券额转增
  router.push({
    path: '/cost/quota-coupon-resend',
    name: 'quotaCouponResend',
    component: QuotaCouponResend,
    meta: {
      isNewVersion: true // 校验权限是否为新版
    }
  })

  //新版券额发放代金券
  router.push({
    path: '/cost/quota-coupon-issue',
    name: 'quotaCouponIssue',
    component: QuotaCouponIssue,
    meta: {
      isNewVersion: true // 校验权限是否为新版
    }
  })
}
